exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cockpit-popper.el-popover{position:relative!important;top:0!important;padding:5px!important;min-width:68px!important;font-size:12px!important;text-align:center;color:rgba(175,252,255,.8);background:var(--businessTabPopoverBg);border:1px solid var(--businessTabPopoverBorder)!important}.cockpit-popper.el-popover[x-placement^=bottom] .popper__arrow,.cockpit-popper.el-popover[x-placement^=bottom] .popper__arrow:after{background:hsla(0,0%,100%,0)!important;border-bottom-color:#0d666f}", ""]);

// exports
